import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Grid from './Grid';
import Cell from './Cell';
import H2 from './H2';
import FaqList from './FaqList';
import BlockWave from './BlockWave';

const PageFAQs = ({ content, selectedLocale }) => (
  <BlockWave id={content.internal_link_id}>
    <Grid>
      <Cell
        size={1}
        px="baseUnit"
        py={{ mobile: 'baseUp8', tablet: 'baseUp12' }}
      >
        <H2 pb={{ mobile: 'baseUnit', tablet: 'baseUp4' }} color="coral">
          {content.title1.text}
        </H2>

        <FaqList selectedLocale={selectedLocale} />
      </Cell>
    </Grid>
  </BlockWave>
);

PageFAQs.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
  content: PropTypes.shape({
    internal_link_id: PropTypes.string,
    title1: PropTypes.shape({
      text: PropTypes.string,
    }),
  }).isRequired,
};

export default PageFAQs;

export const query = graphql`
  fragment PageFAQsFragment on PrismicPageDataBodyFaqs {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
    }
  }
`;
